import { useTranslation } from "react-i18next";

export default function useMajorFilter() {
  const { t } = useTranslation();

  const currencies = [
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" },
    { label: "TRY", value: "TRY" },
    { label: "GBP", value: "GBP" },
  ];

  const filters = [
    {
      key: "name",
      label: t("university.majorName") || "Major Name",
      type: "text",
    },
    {
      key: "currency",
      label: t("common.currency") || "Currency",
      type: "select",
      mode: "multiple",
      options: currencies,
    },
    {
      key: "status",
      label: t("common.status") || "Status",
      type: "select",
      mode: "multiple",
      options: [
        { label: t("common.show") || "Show", value: "true" },
        { label: t("common.hide") || "Hide", value: "false" },
      ],
    },
    {
      key: "dateRange",
      label: t("common.createdAt") || "Created At",
      type: "dateRange",
    },
  ];

  return filters;
}
